import React from 'react'
import {Reducer} from '../../state/settings/get-settings/reducer'
import {getSettings} from '../../state/settings/get-settings/actions'

const SettingsContext = React.createContext(null)

function SettingsContextProvider(props) {
  const userState = {
    error: null,
    isLoading: false,
  }

  const [state, dispatch] = React.useReducer(Reducer, userState)

  const getSettingsApi = React.useCallback(() => getSettings(dispatch), [])

  React.useEffect(() => {
    getSettingsApi(dispatch)
  }, [getSettingsApi])

  const value = {
    ...state,
  }

  return <SettingsContext.Provider value={value}>{props.children}</SettingsContext.Provider>
}

const SettingsContextConsumer = SettingsContext.Consumer

export {SettingsContext, SettingsContextProvider, SettingsContextConsumer}
